import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import ProductImage from '@/components/product/ProductImage';
import { formatUrl, getHrefForProductLink } from '@/utils/linkUtils';
import { normalizeUrl } from '@/utils/menuUtils';
import { isKrugOrWhispering } from '@/utils/millesimaUtils';
import { getProductImage } from '@/utils/productUtils';

import styles from './ProductCardImage.module.scss';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

const ProductCardImage = ({ product, currentItem, storeConf, position }) => {
  const router = useRouter();
  const { isDesktop } = useScreenSizeContext();
  const imgSize = isDesktop ? 'thumb' : 'mobile';
  const url = getProductImage(currentItem.image ? currentItem.image : product.image, false, imgSize);
  

  const productSizeList = product?.image === product?.imageSize?.fileName ? product.imageSize.sizeByFolder : null;
  const itemSizeList = currentItem.image === currentItem?.imageSize?.fileName ? currentItem?.imageSize?.sizeByFolder : null;
  const compareItemAndProduct = currentItem.image === product?.imageSize?.fileName ? product?.imageSize?.sizeByFolder : null;

  const handleClick = () => {
    if (isKrugOrWhispering(product.seoKeyword)) {
      window.location.href = normalizeUrl(product.seoKeyword);
    } else {
      const href = getHrefForProductLink(product.seoKeyword, product._id, currentItem.partnumber, product.isSpirit);
      const as = formatUrl(product.seoKeyword, product.isSpirit, storeConf);

      router.push({ href, as }, product.seoKeyword);
    }
  };

  return (
    <ProductImage
      url={url}
      alt={product.productName}
      sizeList={compareItemAndProduct || itemSizeList || productSizeList}
      size={imgSize}
      position={position}
      id={product._id}
      seoKeyword={product.seoKeyword}
      partnumber={currentItem.partnumber}
      onClick={handleClick}
      customClassName={styles.image}
    />
  );
};

ProductCardImage.propTypes = {
  product: PropTypes.shape({
    _id: PropTypes.string,
    seoKeyword: PropTypes.string,
    productName: PropTypes.string,
    image: PropTypes.string,
    imageSize: PropTypes.object,
    isSpirit: PropTypes.bool
  }).isRequired,
  currentItem: PropTypes.shape({
    partnumber: PropTypes.string
  }).isRequired,
  position: PropTypes.number,
  storeConf: PropTypes.object.isRequired
};

export default ProductCardImage;
